import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  styled,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const NAV_ITEMS = [
  { name: "Dashboard", path: "/", permission: null },
  { name: "Projects", path: "/projects", permission: "view_projects" },
  { name: "Model Zoo", path: "/model-zoo", permission: "view_model_zoo" },
  {
    name: "V4P Model Zoo",
    path: "/v4p-model-zoo",
    permission: "view_v4p_model_zoo",
  },
  { name: "QM Blueprint", path: "/qm-blueprint", permission: null },
  { name: "App Zoo", path: "/app-zoo", permission: "view_app_zoo" },
];

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [permissions, setPermissions] = useState([]);
  const [isGuest, setIsGuest] = useState(false);

  useEffect(() => {
    axios
      .get("/auth/me")
      .then((res) => {
        setPermissions(res.data.permissions);
        setIsGuest(res.data.user_type === "guest");
      })
      .catch(() => setPermissions([]));
  }, []);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleSignOut = () => {
    handleMenuClose();
    navigate("/login");
  };

  return (
    <AppBar
      position="sticky"
      color="white"
      sx={{
        backgroundColor: "white",
        boxShadow: "0 1px 0 0 #f5f5f5",
        borderBottom: "0.2px solid rgb(226, 226, 226)",
        borderBottomLeftRadius: "4px",
        borderBottomRightRadius: "4px",
        overflow: "hidden",
      }}
    >
      <StyledToolbar sx={{ px: "2vw", py: "0.15vw", ml: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src="/FM_logo.svg"
            alt="Flanders Make"
            style={{ height: 24, width: "auto", display: "block" }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 7, mr: 3 }}>
          {NAV_ITEMS.filter(({ guestVisible }) => !isGuest || guestVisible).map(
            ({ name, path, permission }) => {
              const allowed = !permission || permissions.includes(permission);
              return allowed ? (
                <NavLink
                  key={name}
                  to={path}
                  style={({ isActive }) => ({
                    textDecoration: "none",
                    color: isActive ? "rgb(85, 81, 81)" : "inherit",
                    fontWeight: isActive ? "bold" : "normal",
                    fontSize: "1vw",
                  })}
                >
                  {name}
                </NavLink>
              ) : (
                <span
                  key={name}
                  style={{
                    fontSize: "1vw",
                    color: "rgb(190, 190, 190)",
                    cursor: "not-allowed",
                  }}
                >
                  {name}
                </span>
              );
            },
          )}

          <IconButton onClick={handleMenuOpen} size="small">
            <Avatar
              alt="UserName"
              src="avatar.png"
              sx={{ width: "2.5vw", height: "2.5vw" }}
            />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            PaperProps={{
              elevation: 2,
              sx: { mt: 1.5, borderRadius: 2, minWidth: 150 },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
          </Menu>
        </Box>
      </StyledToolbar>
    </AppBar>
  );
};

export default Header;
